import { Link } from 'react-router-dom';

import SuccessIcon from 'assets/icons/base/success-icon.svg';
import Kassa24Logo from 'assets/images/kassa-mini-logo-black.svg';
import { useAppSelector } from 'store/hooks';

import { BaseCard } from '../ui';

const CheckSuccess = () => {
  const { paymentData } = useAppSelector((state) => state.payment);

  return (
    <BaseCard>
      <div className="bg-white md:bg-base-gray-100 flex-grow w-full h-full md:rounded-large col-start-1 col-end-3 flex flex-col justify-center items-center text-center gap-8 p-8">
        <div className="flex flex-col gap-8 max-w-[330px] items-center justify-center flex-grow">
          <img src={SuccessIcon} alt="logo" />

          {paymentData?.ID && (
            <dl className="text-sm leading-5">
              <dt>Заказ</dt>
              <dd className="font-bold">{paymentData.ID}</dd>
            </dl>
          )}

          <dl className="text-sm leading-5">
            <dt className="text-base leading-6 font-bold mb-2">Этот счет уже был выплачен</dt>

            <dd className="check-error__info-description">
              <Link
                to={{
                  pathname: '/payment/viewcheck',
                  search: `?id=${paymentData?.ID}`,
                }}
                className="text-base-blue-100"
              >
                Чек
              </Link>{' '}
              отправлен вам на почту
            </dd>
          </dl>
        </div>
        <div className="block md:hidden">
          <Link to="/">
            <img src={Kassa24Logo} alt="kassa24" />
          </Link>
        </div>
      </div>
    </BaseCard>
  );
};

export { CheckSuccess };
